import { cn } from '@/lib/utils';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'success' | 'warning' | 'danger' | 'info' | 'secondary';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const variantStyles = {
  default: 'bg-muted text-muted-foreground border-border',
  success: 'bg-chart-4/20 text-chart-4 border-chart-4',
  warning: 'bg-secondary/20 text-secondary-foreground border-secondary',
  danger: 'bg-destructive text-destructive-foreground border-destructive',
  info: 'bg-accent/20 text-accent-foreground border-accent',
  secondary: 'bg-chart-5/20 text-chart-5 border-chart-5',
};

const sizeStyles = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-2.5 py-1 text-sm',
  lg: 'px-3 py-1.5 text-base',
};

export function Badge({ children, variant = 'default', size = 'sm', className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md border font-medium',
        variantStyles[variant],
        sizeStyles[size],
        className
      )}
    >
      {children}
    </span>
  );
}
